import React, { useState, useEffect } from "react";
import api from '../api';
import { Link, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { setIsFavorite } from "../redux/reducers/brandReducer";
import ModalShare from "./ModalShare";
import {getEnv} from '../api/environments';
interface User {
  company_type: string;
  company?: {
    id: number;
    shortname?: string;
  };
}

interface Brand {
  id: number;
  is_favorite?: boolean;
  shortname?: string;
}

interface Agency {
  id: number;
  is_favorite?: boolean;
  shortname?: string;
}

interface LikeSaveBtnsProps {
  user: User;
  brand: Brand;
  agency: Agency;
}

const LikeSaveBtns = ({ user, brand, agency }: LikeSaveBtnsProps) => {
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;
  
  const [isLoading, setIsLoading] = useState(true);
  
  const [isFavorite, setIsFavoriteState] = useState(Boolean(brand?.is_favorite));

  const [isSharing, setIsSharing] = useState(false);

  const [shareUrl, setShareUrl] = useState('');

  const isBrandowner = user?.company_type === 'brandowners';

  useEffect(() => {
    if (brand?.id && user?.company_type && user?.company?.id && !isBrandowner) {
      setIsLoading(true);
      fetchFavoriteStatus(brand.id);
    } else {
      setIsLoading(false);
    }  
    if(pathname.split('/')[1].toLowerCase() === "brand"){
      if(brand?.shortname){
        setShareUrl(`${getEnv('BASE_PATH')}view/brand/${brand.shortname}`)
      }
    }else if(pathname.split('/')[1].toLowerCase() === "agency"){
      if(agency?.shortname){
        setShareUrl(`${getEnv('BASE_PATH')}view/agency/${agency.shortname}`)
      }
    }
    

  }, [brand?.id, user?.company_type, user?.company?.id, agency?.id, isBrandowner ]);

  const fetchFavoriteStatus = (brandId: number) => {
    if (!user?.company?.id || isBrandowner) {
      setIsLoading(false);
      return;
    }
    
    console.log("Fetching favorite status for brand ID:", brandId);
    
    api.getFavorites(
      {
        owner: user.company_type,
        owner_id: user.company.id,
        preference: 'favorite'
      },
      (res) => {
        if (res.status === 200) {
          const isFav = res.data.some(fav => {
            let fav_id;
            
            if (user.company_type === "brandowners") {
              fav_id = fav.id;
              return fav_id === brandId;
            } else {
              fav_id = fav.id;
              return fav_id === brandId;
            }
          });
          
          
          
          setIsFavoriteState(isFav);
          dispatch(setIsFavorite(isFav));
        }
        setIsLoading(false);
      }
    );
  };

  const handleToggleFavorite = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isLoading || !brand?.id || !user?.company?.id || isBrandowner) return;

    const newFavoriteStatus = !isFavorite;
        
    setIsFavoriteState(newFavoriteStatus);
    setIsLoading(true);

    const payload = {
      owner: user.company_type,
      brand_id: user.company_type === "brandowners" ? user.company.id : brand.id,
      agency_id: user.company_type === "brandowners" ? brand.id : user.company.id,
      preference: 'favorite'
    };
    
    api.toggleFavorite(
      payload,
      (res) => {        
        if (res.status === 200) {
          const serverFavoriteStatus = res.data.hasOwnProperty('is_favorite') 
            ? res.data.is_favorite 
            : newFavoriteStatus;        
          dispatch(setIsFavorite(serverFavoriteStatus));
          setIsFavoriteState(serverFavoriteStatus);
          
          if (brand?.id) {
            fetchFavoriteStatus(brand.id);
          }
        } else {
          setIsFavoriteState(isFavorite);
        }
        setIsLoading(false);
      }
    );
  };

  const handleShowShareModal = () => {
    setIsSharing(true);
  }

  const handleCloseShareModal = () => {
    setIsSharing(false);
  };

  const heartFill = isFavorite ? "red" : "none";
  const buttonText = isLoading ? "Loading..." : (isFavorite ? "Remove from Favorites" : "Add to Favorites");

  return (
    <div className="flow-root">
      <div className="flex text-neutral-700 dark:text-neutral-300 text-sm -mx-3 -my-1.5">
        <Link to={'#'} onClick={() => handleShowShareModal()} className={`py-1.5 px-3 flex rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 ${isLoading ? 'opacity-50' : 'cursor-pointer'}`}>
          <svg 
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
            />
          </svg>
          <span className="hidden sm:block ml-2.5">Share</span>
        </Link>
        
        {!isBrandowner && (
          <Link to={'#'} onClick={handleToggleFavorite} className={`py-1.5 px-3 flex rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 ${isLoading ? 'opacity-50' : 'cursor-pointer'}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill={heartFill} 
              viewBox="0 0 24 24" 
              stroke="currentColor"
              >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
              />
            </svg>
            <span className="hidden sm:block ml-2.5">{buttonText}</span>
          </Link>
        )}
          {isSharing && (
            <ModalShare shareUrl={shareUrl} show={isSharing} handleClose={handleCloseShareModal} />
          )
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.user?.user,
  brand: state.brand?.brand,
  agency: state.agency?.agency,
});

export default connect(mapStateToProps)(LikeSaveBtns);